import { NAME_COMPENSATION, NAME_CAMPAIGN_ASSETS, NAME_CONTENT_AGREEMENT, NAME_PRODUCTS, NAME_PERSONAL_INFO, NAME_SHIPPING_INFO, NAME_TASKS, NAME_NETWORKS } from './proposal-steps';
export default {
    [NAME_COMPENSATION]: 'v2.campaign.proposal.compensation',
    [NAME_PRODUCTS]: 'v2.campaign.proposal.products',
    [NAME_TASKS]: 'v2.campaign.proposal.tasks',
    [NAME_NETWORKS]: 'v2.campaign.proposal.networks',
    [NAME_SHIPPING_INFO]: 'v2.campaign.proposal.shippingInfo',
    [NAME_PERSONAL_INFO]: 'v2.campaign.proposal.personalInfo',
    [NAME_CAMPAIGN_ASSETS]: 'v2.campaign.proposal.assets',
    [NAME_CONTENT_AGREEMENT]: 'v2.campaign.proposal.agreements'
};
